class Forbidden extends Error {
    constructor(message = 'Forbidden. You do not have the right permissions to access this resource.') {
      super(message)
      this.name = this.constructor.name
      this.status = 403
      Error.captureStackTrace(this, this.constructor)
    }
}

module.exports = Forbidden
